import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sm:container w-full mx-auto sm:p-4 space-y-6 max-w-full" }
const _hoisted_2 = { class: "grid sm:grid-cols-2 md:grid-cols-3 gap-6" }
const _hoisted_3 = { class: "md:col-span-2" }
const _hoisted_4 = { class: "space-y-9" }

import { ref, onMounted } from 'vue'
import { Toaster } from '@/components/ui/toast'
import ProfileBox from './components/ProfileBox.vue'
import { useAxios } from '@/composables/useAxios'
import ProfileSkeleton from './components/ProfileSkeleton.vue'
import CommentsSection from './components/commentsSection/CommentsSection.vue'
import { Profile } from '@/interfaces/profiles/Profile'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  props: {
    profileId: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const user = ref<Profile>()

function getProfile() {
  axios.get(`/profile/${props.profileId}`)
    .then((res) => {
      user.value = { ...res.data, phoneNumber: res.data.phoneNumber?.slice(2,) }
    })
    .catch(err => {
      console.error('Error fetching profile:', err);
    })
}

onMounted(async () => {
  getProfile()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ProfileBox, {
            onUpdate: getProfile,
            user: user.value,
            "profile-id": props.profileId
          }, null, 8, ["user", "profile-id"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CommentsSection, {
            profile: user.value,
            "profile-id": props.profileId
          }, null, 8, ["profile", "profile-id"])
        ])
      ])
    ]),
    _createVNode(_unref(Toaster))
  ], 64))
}
}

})